// extracted by mini-css-extract-plugin
module.exports = {"banner-line":"BannerLine_banner-line__2w1us","slide":"BannerLine_slide__1IQii","link":"BannerLine_link__fjUM3"};